module.exports = __webpack_public_path__ + "img/ECR-100.b16e224f.png";